import React, { Component } from "react";
import { Header, Footer } from '@deere/ux.uxframe-react';

class InternalLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prosNumber: this.props.match.params.value1,
            loginBy: this.props.match.params.value2,
            render: false
        }
    }

    componentDidMount() {
        let prosNumber = this.state.prosNumber;
        this.loadSupplierDetails(prosNumber);
    }

    loadSupplierDetails = (prosNumber) => {
        let loginBy = this.state.loginBy;
        if (loginBy != null) {
            document.location.href = "/deere-summary/" + prosNumber + "/" + loginBy;
        } else {
            this.setState({ render: true });
        }
    }
    render() {
        return (
            <div>
                {this.state.render ?
                    <div>
                        <Header pageHeading="Prospective Supplier" />
                        <br></br><br></br>
                        <h3 align="center">Sorry! You are unauthorized to access this application.</h3>
                        <br></br><br></br>
                        <div><Footer /></div>
                    </div>
                    : null}
            </div>
        );
    }
}
export default InternalLogin;